import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { IS_SAAS } from "@coso/utility";
import { of, throwError } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { map } from "rxjs/operators";
import { ISharePointStructureCreatorLicenseInfo, ISummaryLicenseInfo, IUserLicenseInfo } from "../models";

@Injectable({
  providedIn: "root"
})
export class LicenseService {
  private baseRoute = `/api/license`;
  constructor(@Inject(IS_SAAS) private isSaaS: boolean, private http: HttpClient) {}

  get(id?: string): Observable<ISummaryLicenseInfo> {
    let params = new HttpParams();
    if (id) {
      params = params.append("instanceId", id);
    }
    return this.isSaaS ? throwError("Unsupported operation!") : this.http.get<ISummaryLicenseInfo>(this.baseRoute, { params });
  }

  getUserLicenseInfo(id: string): Observable<IUserLicenseInfo> {
    const params = new HttpParams().append("instanceId", id);
    return this.http.get<IUserLicenseInfo>(`${this.baseRoute}/user`, { params: params });
  }

  getSscLicenseInfo(id: string): Observable<ISharePointStructureCreatorLicenseInfo> {
    const params = new HttpParams().append("instanceId", id);
    return this.http.get<ISharePointStructureCreatorLicenseInfo>(`${this.baseRoute}/sharepoint-structure-creator`, { params: params });
  }

  isFailOverAllowed(): Observable<boolean> {
    return this.isSaaS ? of(false) : this.http.get<ISummaryLicenseInfo>(this.baseRoute).pipe(map((licenseInfo) => (licenseInfo.features?.highAvailability || licenseInfo.sharePointStructureCreatorLicenseInfo.features?.highAvailability) ?? false));
  }
}
